import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { initializeDatadog } from './app/monitoring/initializeDatadog';
import { environment } from './environments/environment';


if (environment.production) {
    try {
        initializeDatadog();
    } catch (err) {
        console.error('Datadog init failed', err);
    }

    enableProdMode();
}

platformBrowserDynamic()
    .bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
    .catch((err) => console.error(err));
